import React, { useContext, useEffect, useState } from 'react';
import { Button, Form, Header, Image, Message, Segment } from 'semantic-ui-react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { UserContext } from '../context/User';
import { API, getLogo, getSystemName, showError, showSuccess, showWarning } from '../helpers';
import PolicyLinks from './PolicyLinks';

const LoginForm = () => {
  const [inputs, setInputs] = useState({
    username: '',
    password: '',
    wechat_verification_code: ''
  });
  const [searchParams] = useSearchParams();
  const { username, password } = inputs;
  const [, userDispatch] = useContext(UserContext);
  const navigate = useNavigate();
  const logo = getLogo();
  const systemName = getSystemName();

  useEffect(() => {
    if (searchParams.get('expired')) {
      showError('未登录或登录已过期，请重新登录！');
    }
  }, [searchParams]);

  function handleChange(e) {
    const { name, value } = e.target;
    setInputs((current) => ({ ...current, [name]: value }));
  }

  async function handleSubmit(e) {
    if (e) {
      e.preventDefault();
    }
    if (!username || !password) {
      showWarning('请输入用户名和密码');
      return;
    }

    const res = await API.post(`/api/user/login`, {
      username,
      password
    });
    const { success, message, data } = res.data;
    if (success) {
      userDispatch({ type: 'login', payload: data });
      localStorage.setItem('user', JSON.stringify(data));
      if (username === 'root' && password === '123456') {
        navigate('/user/edit');
        showSuccess('登录成功！');
        showWarning('请立刻修改默认密码！');
      } else {
        navigate('/token');
        showSuccess('登录成功！');
      }
    } else {
      showError(message);
    }
  }

  return (
    <div className='auth-shell'>
      <Segment className='auth-card'>
        <div className='auth-brand'>
          <span className='auth-brand-mark'>
            <Image src={logo} />
          </span>
          <div className='auth-brand-copy'>
            <div className='auth-brand-kicker'>{systemName}</div>
            <Header as='h2' className='auth-title'>
              登录控制台
            </Header>
            <div className='auth-subtitle'>
              访问模型目录、令牌管理与调用日志。
            </div>
          </div>
        </div>

        <Form size='large' className='auth-form' onSubmit={handleSubmit}>
          <Segment className='auth-form-panel'>
            <Form.Input
              fluid
              icon='user'
              iconPosition='left'
              label='用户名'
              placeholder='用户名'
              name='username'
              value={username}
              onChange={handleChange}
            />
            <Form.Input
              fluid
              icon='lock'
              iconPosition='left'
              label='密码'
              placeholder='密码'
              name='password'
              type='password'
              value={password}
              onChange={handleChange}
            />
            <Button primary fluid size='large' type='submit' className='auth-submit-button'>
              登录
            </Button>
          </Segment>
        </Form>

        <Message className='auth-helper-message'>
          <span>忘记密码？</span>
          <Link to='/reset' className='auth-helper-link'>
            点击重置
          </Link>
          <span>； 没有账户？</span>
          <Link to='/register' className='auth-helper-link'>
            点击注册
          </Link>
        </Message>

        <PolicyLinks />
      </Segment>
    </div>
  );
};

export default LoginForm;
